<app-external-page>
    <div 
        class="error-container" 
        fxLayoutAlign="center center"
        content-container>
        <div fxFlex="500px" fxFlex.xs="100%" fxLayoutAlign="center center">
            <div fxLayout="row" 
                fxLayoutGap="30px" 
                fxLayoutGap.lt-md="20px">
                <fa-icon icon="exclamation"></fa-icon>
                <div 
                    fxLayout="column" 
                    fxLayoutAlign="center center" 
                    fxLayoutGap="20px" 
                    fxLayoutGap.lt-md="16px">
                    <div class="mat-headline">
                        Pagina não encontrada!
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-external-page>